var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoNotepad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8452 119.999C92.8968 119.999 119.69 93.1585 119.69 60.0486C119.69 26.9386 92.8968 0.0976562 59.8452 0.0976562C26.7936 0.0976562 0 26.9386 0 60.0486C0 93.1585 26.7936 119.999 59.8452 119.999Z",
    fill: "#116EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 32.4717H23.938V108.01C35.6168 116.78 50.0924 120.972 64.6409 119.797C79.1894 118.622 92.8078 112.162 102.934 101.631V32.4717Z",
    fill: "#D9EDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 38.4668H23.938V39.6658H102.934V38.4668Z",
    fill: "#C3DAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 45.6611H23.938V46.8602H102.934V45.6611Z",
    fill: "#C3DAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 52.8545H23.938V54.0535H102.934V52.8545Z",
    fill: "#C3DAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 60.0488H23.938V61.2478H102.934V60.0488Z",
    fill: "#C3DAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 67.2432H23.938V68.4422H102.934V67.2432Z",
    fill: "#C3DAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 74.4375H23.938V75.6365H102.934V74.4375Z",
    fill: "#C3DAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 81.6309H23.938V82.8299H102.934V81.6309Z",
    fill: "#C3DAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 88.8252H23.938V90.0242H102.934V88.8252Z",
    fill: "#C3DAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 96.0195H23.938V97.2186H102.934V96.0195Z",
    fill: "#C3DAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.354 103.214H23.938V104.413H100.097C100.54 104.029 100.935 103.622 101.354 103.214Z",
    fill: "#C3DAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2934 110.408H27.3972C28.0196 110.828 28.6659 111.224 29.3123 111.607H90.3544C91.0246 111.224 91.671 110.828 92.2934 110.408Z",
    fill: "#C3DAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9536 102.854C28.3539 113.066 42.1141 119.128 56.6561 119.905C71.198 120.682 85.5238 116.12 96.9493 107.075V39.666H17.9536V102.854Z",
    fill: "#F6FDFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 45.6611H17.9536V46.8602H96.9493V45.6611Z",
    fill: "#C3DAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 52.8545H17.9536V54.0535H96.9493V52.8545Z",
    fill: "#C3DAFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 60.0488H17.9536V61.2478H96.9493V60.0488Z",
    fill: "#C3DAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 67.2432H17.9536V68.4422H96.9493V67.2432Z",
    fill: "#C3DAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 74.4375H17.9536V75.6365H96.9493V74.4375Z",
    fill: "#C3DAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 81.6309H17.9536V82.8299H96.9493V81.6309Z",
    fill: "#C3DAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 88.8252H17.9536V90.0242H96.9493V88.8252Z",
    fill: "#C3DAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 96.0195H17.9536V97.2186H96.9493V96.0195Z",
    fill: "#C3DAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 103.214H17.9536V104.413H96.9493V103.214Z",
    fill: "#C3DAFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2814 110.408H27.3972C28.0316 110.816 28.6659 111.224 29.3123 111.607H90.3544C90.9648 111.224 91.647 110.828 92.2814 110.408Z",
    fill: "#C3DAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.602 117.602H43.0886C44.6566 118.069 46.2485 118.477 47.8762 118.801H71.7306C73.3823 118.477 74.9981 118.069 76.602 117.602Z",
    fill: "#C3DAFA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoNotepad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/InfoNotepad.d8afd7372c976ef654812a84c4df8e5c.svg";